var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPaperPlane = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 120 120"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 60,
  r: 60,
  fill: "#F6F9FC"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M89.14 35.672a.695.695 0 0 0-.601-1.25L33.003 57.785a1.377 1.377 0 0 0-.248 2.398l7.026 3.889 49.359-28.4ZM45.662 67.612l33.103-22.75L47.79 72.772l-2.129-5.16ZM53.42 83.188l1.405-10.84 5.794 3.736-7.198 7.104Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.895,
  d: "M85.57 35 30.735 57.785a1.195 1.195 0 0 0-.156 2.13l12.817 7.699c.237.142.417.362.51.622l5.196 14.597a1.197 1.197 0 0 0 2.05.355l5.628-6.856a1.196 1.196 0 0 1 1.568-.248l15.073 9.646a1.194 1.194 0 0 0 1.806-.723l11.96-48.615a1.197 1.197 0 0 0-1.617-1.39v0Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.895,
  d: "m52.557 72.347 23.942-27.489-33.102 22.754M52.556 72.349l-1.404 10.839 7.199-7.104-5.795-3.735Z"
})));
export default SvgPaperPlane;